import { render, staticRenderFns } from "./opportunityCompaniesModale.vue?vue&type=template&id=58a2bd14&scoped=true&"
import script from "./opportunityCompaniesModale.vue?vue&type=script&lang=js&"
export * from "./opportunityCompaniesModale.vue?vue&type=script&lang=js&"
import style0 from "./opportunityCompaniesModale.vue?vue&type=style&index=0&id=58a2bd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2bd14",
  null
  
)

export default component.exports